import gql from 'graphql-tag'

export default gql`
mutation ($_id:[MongoID],$selectAll : Boolean, $eventId : String) {
    removeParticipants (_id:$_id, selectAll : $selectAll, eventId: $eventId) {
        checkStatus
    }
}
`
